
































































import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { atSignedLogin } from '../../../../shared/utils/tgLoginHelpers'
import UserMainInfo from "../../../UserMainInfo.vue";

@Component({
  data() {
    return {
      isMobile,
      atSignedLogin
    }
  },
  components: {
    UserMainInfo
  }
})
export default class UserInfo extends Vue {
  @Prop() avatar_url!: string

  @Prop() banned!: boolean

  @Prop() login!: string

  @Prop() name!: string

  @Prop() labels!: Array<string>

  @Prop() user_id!: number

  tooltipIsOpen = false

  get previewLabels() {
    return this.labels.slice(0,4)
  }
}
